export const STATUS_BANNER_VARIANTS = {
  FEATURE_PAUSED: 'featurePaused',
  CREDITS_RESET: 'creditsReset',
  CREDITS_ADDED: 'creditsAdded',
  CREDIT_PLAN_WILL_UPGRADE: 'creditPlanWillUpgrade',
  CREDIT_PLAN_UPGRADED: 'creditPlanUpgraded'
};